import Request from '../utils/request';
const contractPath = '/landTransportApi/driver/app/truckBrokerContract' // 合同地址

// 查询合同H5列表
export async function contractPathList(params) {
  let requestUrl = `${contractPath}/contractPathList`;
  return Request(requestUrl, {
    method: 'POST',
    body: {
      ...params,
    },
  });
}

// 查询合同H5详情 
export async function contractPathInfo(params){
  let url = `${contractPath}/contractPathInfo`;
  return Request(url, {
     method: 'POST',
     body:{
       ...params,
     }
  });
}

// 新增预览合同记录
export async function insertContractH5Record(params) {
  let requestUrl = `${contractPath}/insertContractH5Record`;
  return Request(requestUrl, {
    method: 'POST',
    body: {
      ...params,
    },
  });
}



// WEBPACK FOOTER //
// ./src/services/contractManage.js